const buildLegacyGroupManagement = (groupList = [], subsetAttributeKeys) => {
  const groupManagement = {
    entryHash: {},
    associationHash: {
      year: {},
      class: {},
      custom: {},
      subject: {}
    }
  };

  groupList.forEach((clientStudentGroup) => {
    const entryId = clientStudentGroup.id;
    const entry = {
      name: clientStudentGroup.group,
      parentId: '',
      parentType: ''
    };
    groupManagement.entryHash[entryId] = entry;

    subsetAttributeKeys.forEach((subsetAttributeKey) => {
      const subsetAttributeValue = clientStudentGroup[subsetAttributeKey];
      if (typeof subsetAttributeValue !== 'undefined') {
        entry[subsetAttributeKey] = subsetAttributeValue;
      }
    });

    if (clientStudentGroup.school) {
      entry.parentId = `${clientStudentGroup.school}`;
      entry.parentType = 'school';
      groupManagement.associationHash.year[entryId] = true;
    } else if (clientStudentGroup.parent) {
      entry.parentId = `${clientStudentGroup.parent}`;
      entry.parentType = 'group';
      if (clientStudentGroup.subjectGroup) {
        groupManagement.associationHash.subject[entryId] = true;
      } else {
        groupManagement.associationHash.class[entryId] = true;
      }
    } else if (clientStudentGroup.customGroup) {
      groupManagement.associationHash.custom[entryId] = true;
    }
  });

  return groupManagement;
};

export default buildLegacyGroupManagement;
